import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { PuiCloseButton, Text } from '@pbt/pbt-ui-components'

import styles from './RhapConfirmCloseDialog.module.scss'

interface RhapConfirmCloseDialogProps {
  bodyText?: string
  onCancelClose?: () => void
  onCancelCloseLabel?: string
  onClose: () => void
  onConfirmClose?: () => void
  onConfirmCloseLabel?: string
  open: boolean
  title?: string
}

/**
 * Confirm close dialog with Chirp style buttons and customizable confirm / cancel logic.
 * For legacy component that enforces saving, use ConfirmCloseDialog from pbt-ui-components.
 */
export function RhapConfirmCloseDialog({
  bodyText,
  open,
  onClose,
  onCancelClose,
  onConfirmClose,
  onCancelCloseLabel,
  onConfirmCloseLabel,
  title: titleProp,
}: RhapConfirmCloseDialogProps) {
  const { t } = useTranslation(['Dialogs', 'Common'])
  const title = titleProp || t('Dialogs:CONFIRM_CLOSE_DIALOG.TITLE')
  const confirmCloseLabel =
    onConfirmCloseLabel || t('Dialogs:CONFIRM_CLOSE_DIALOG.CONFIRM_CLOSE_LABEL')
  const cancelCloseLabel = onCancelCloseLabel || t('Common:BACK_ACTION')

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={styles.header}>
        <DialogTitle className={styles.dialogTitle}>{title}</DialogTitle>
        <PuiCloseButton onClick={onClose} />
      </div>
      <DialogContent>
        {bodyText && (
          <Text className={styles.bodyText} variant="body">
            {bodyText}
          </Text>
        )}
        <div className={styles.actions}>
          {onConfirmClose && (
            <KibButtonNew onClick={onConfirmClose}>
              {confirmCloseLabel}
            </KibButtonNew>
          )}
          {onCancelClose && (
            <KibButtonNew emphasis="secondary" onClick={onCancelClose}>
              {cancelCloseLabel}
            </KibButtonNew>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
